"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Message_1 = __importStar(require("../../components/message/Message"));
const util_1 = require("./util");
const ErrorMessage_1 = __importDefault(require("../message/ErrorMessage"));
const Overlay_1 = __importDefault(require("../overlay/Overlay"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const RedeemActions_1 = __importDefault(require("../../actions/RedeemActions"));
const RedeemContainer_1 = __importDefault(require("./RedeemContainer"));
const SquareButton_1 = __importDefault(require("../squareButton/SquareButton"));
const _1 = require("./");
const classnames_1 = __importDefault(require("classnames"));
const epic_tracking_1 = __importDefault(require("epic-tracking"));
class ValidateStage extends react_1.default.Component {
    constructor(props) {
        super(props);
        /**
         * Check Code Client Side if code looks like a VBucks Card Code and not Redeem Code
         */
        this.checkPosaCode = currentValue => {
            //if posa is not enabled just return false.
            if (!this.props.enablePosa)
                return false;
            return util_1.isPosaCode(currentValue);
        };
        /**
         * Event handler for form field input
         */
        this.handleInput = evt => {
            const currentValue = evt.target.value;
            this.setState({
                codeInput: currentValue
            });
        };
        /**
         * Event handler for submitting form with Enter key
         */
        this.handleEnterSubmit = evt => {
            if (evt.keyCode === 13) {
                this.handleSubmit();
            }
        };
        /**
         * Event handler for submitting form through clicking Redeem button
         */
        this.handleSubmit = () => {
            const code = (this.state.codeInput || '').trim();
            const couldBePosaCode = this.checkPosaCode(code);
            if (this.props.enablePosa && couldBePosaCode && !this.state.showOverlay) {
                this.setState({ couldBePosaCode, showOverlay: true });
            }
            else if (!util_1.isCoupon(code)) {
                epic_tracking_1.default.trackEvent('Interaction', {
                    interactionType: 'click',
                    eventCategory: 'RedeemCode',
                    eventAction: 'inValidCodeShortOrMissing'
                });
                // stop submit if code length under 20 characters
                this.setState({
                    localErrorMessage: 'errors.com.epicgames.code.redemption.code_length',
                    showOverlay: false
                });
            }
            else {
                epic_tracking_1.default.trackEvent('Interaction', {
                    interactionType: 'click',
                    eventCategory: 'RedeemCode',
                    eventAction: 'validatingCode'
                });
                RedeemActions_1.default.validateCode({
                    codeInput: this.state.codeInput,
                    isLoggedIn: this.props.isLoggedIn,
                    talonFlowId: this.props.config.epicgames.talonFlowId
                });
                RedeemActions_1.default.setNextStage(this.props.nextStage);
                this.setState({
                    localErrorMessage: ''
                });
            }
        };
        this.toggleOverlay = () => {
            this.setState({
                showOverlay: !this.state.showOverlay
            });
        };
        this.getRedeemRedirectLink = href => {
            const accountPageName = Message_1.localizedMessage('epic.common.account_management');
            const linkClass = 'redeem-redirect-link';
            const { redeemStore: { redeemCode } } = this.props;
            const codeRedeemRedirect = `${href}?redeemCode=${redeemCode}`;
            return `<a name='redeem-redirect' class=${linkClass} value=${accountPageName} href=${codeRedeemRedirect} target='_blank'>${accountPageName}</a>`;
        };
        this.state = {
            codeInput: props.prefillCode || '',
            localErrorMessage: '',
            couldBePosaCode: false,
            showOverlay: false
        };
    }
    componentDidUpdate(prevProps) {
        const { redeemStore: { redeemCode, validationError, isInvalidCode } } = this.props;
        const { redeemStore: { redeemCode: prevRedeemCode, isInvalidCode: prevIsInvalidCode } } = prevProps;
        const { localErrorMessage } = this.state;
        // Local error message is client side validation and will be tracked in handleSubmit.
        // Redem store contains server side response and tracking is sent if same error is sent for a different code.
        if (!localErrorMessage &&
            validationError &&
            ((isInvalidCode !== prevIsInvalidCode && isInvalidCode) || prevRedeemCode !== redeemCode)) {
            const { code, numericErrorCode } = validationError;
            epic_tracking_1.default.trackEvent('Interaction', {
                interactionType: 'click',
                eventCategory: 'RedeemCode',
                eventAction: 'inValidCode',
                code,
                numericErrorCode
            });
        }
    }
    render() {
        let validateStageView; //content to render
        const config = this.props.config || {};
        if (this.props.redeemStore.loading) {
            validateStageView = react_1.default.createElement("div", { className: "redeemLoading" });
        }
        else {
            const { redeemStore: { validationError }, description, title, posaImage, enablePosa, posaLink } = this.props;
            const isError = !!this.state.localErrorMessage || this.props.redeemStore.isInvalidCode;
            const errorClass = classnames_1.default('errorMessage', { hidden: !isError });
            const inputPlaceholder = Message_1.localizedMessage('epic.code.redemption.validate.input_placeholder');
            const { showOverlay, couldBePosaCode, codeInput } = this.state;
            const msgConfig = config.messages || {};
            const egConfig = config.epicgames || {};
            const egHost = egConfig.host || '';
            const egNamespace = egConfig.namespace || '';
            const codeRedemptionURI = egConfig.codeRedemptionURI || '';
            const upperCaseCode = codeInput.toUpperCase();
            const epicgamesLink = `${egHost}/${egNamespace}/${codeRedemptionURI}`;
            const errorCode = validationError && validationError.code;
            const isSupported = validationError && validationError.isSupported;
            const numericErrorCode = validationError && validationError.numericErrorCode;
            const redirectConfig = {};
            if (!isSupported) {
                redirectConfig.link = this.getRedeemRedirectLink(epicgamesLink);
            }
            validateStageView = (react_1.default.createElement(RedeemContainer_1.default, { className: "redeemContainer" },
                react_1.default.createElement("h1", { className: "site-block-page-title" },
                    react_1.default.createElement(Message_1.default, { code: msgConfig['epic.code.redemption.validate.title'] || 'epic.code.redemption.validate.title' })),
                react_1.default.createElement("div", { className: "site-block" },
                    react_1.default.createElement("div", { className: "site-block-header" },
                        react_1.default.createElement("h1", { className: "site-block-title" }, title ? title : react_1.default.createElement(Message_1.default, { code: "epic.code.redemption.validate.subtitle" })),
                        react_1.default.createElement("div", { className: "clearfix" })),
                    description && react_1.default.createElement("div", { className: "site-block-desc" }, description),
                    react_1.default.createElement("input", { value: this.state.codeInput, type: "text", maxLength: "23", placeholder: inputPlaceholder, onChange: this.handleInput, onKeyDown: this.handleEnterSubmit }),
                    react_1.default.createElement("div", { className: errorClass },
                        this.state.localErrorMessage ? react_1.default.createElement(Message_1.default, { code: this.state.localErrorMessage }) : null,
                        this.props.redeemStore.isInvalidCode && this.state.localErrorMessage === '' && errorCode && (react_1.default.createElement(ErrorMessage_1.default, { msg: errorCode, code: numericErrorCode, args: [redirectConfig.link] }))),
                    react_1.default.createElement("div", { className: "buttonContainer" },
                        react_1.default.createElement(SquareButton_1.default, { handleClick: this.handleSubmit, config: { buttonStyle: 'btn-primary', width: '240px', centered: true } },
                            react_1.default.createElement(Message_1.default, { code: "epic.common.redeem" })))),
                enablePosa && couldBePosaCode && showOverlay ? (react_1.default.createElement(Overlay_1.default, { upperCaseCode: upperCaseCode, image: posaImage, link: posaLink, handleSubmit: this.handleSubmit, close: this.toggleOverlay })) : null));
        }
        return react_1.default.createElement(_1.ValidateStageStyled, { className: "validateStage" }, validateStageView);
    }
}
ValidateStage.propTypes = {
    redeemStore: prop_types_1.default.object,
    nextStage: prop_types_1.default.string,
    prefillCode: prop_types_1.default.string,
    config: prop_types_1.default.object,
    isLoggedIn: prop_types_1.default.bool,
    description: prop_types_1.default.string,
    title: prop_types_1.default.string,
    enablePosa: prop_types_1.default.bool,
    posaImage: prop_types_1.default.string,
    posaLink: prop_types_1.default.string
};
exports.default = ValidateStage;
//# sourceMappingURL=ValidateStage.js.map